import { render } from "./AddLegalServicePayment.vue?vue&type=template&id=4aa4c42b"
import script from "./AddLegalServicePayment.vue?vue&type=script&lang=js"
export * from "./AddLegalServicePayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__